<template>
  <generic-modal :title="$t('update database')" ref="generic_modal">
    <form>
      <div class="field">
        <label class="label">{{ $t("api token") }}</label>
        <div class="control">
          <input class="input" type="text" v-model="meta.api_token" />
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("items number") }}</label>
            <div class="control">
              <input
                class="input"
                type="number"
                v-model="meta.items_number"
                min="1"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("offset") }}</label>
            <div class="control">
              <input class="input" type="number" v-model="meta.offset" />
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("order 1") }}</label>
            <div class="select is-fullwidth">
              <select v-model="meta.order_1">
                <option value="PICKUP">{{ $t("pickup") }}</option>
                <option value="PRICE">{{ $t("price") }}</option>
                <option value="DELIVERYMETROAREA">
                  {{ $t("delivery metro area") }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("order 2") }}</label>
            <div class="select is-fullwidth">
              <select v-model="meta.order_2">
                <option value="PRICE">{{ $t("price") }}</option>
                <option value="DELIVERYMETROAREA">
                  {{ $t("delivery metro area") }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="checkbox pb-2">
            <input
              class="is-checkradio"
              type="checkbox"
              id="chk_show_tagged_on_top"
              name="chk_show_tagged_on_top"
              v-model="meta.show_tagged_on_top"
            />
            <label for="chk_show_tagged_on_top">{{
              $t("show tagged on top")
            }}</label>
          </div>
        </div>
        <!-- <div class="column"></div>  -->
      </div>
      <div class="checkboxes">
        <div class="field">
          <div class="title is-6">{{ $t("vehicle types") }}</div>
          <div class="checkbox pb-2">
            <input
              class="is-checkradio"
              type="checkbox"
              id="chk_car"
              name="chk_car"
              v-model="meta.car"
            />
            <label for="chk_car">{{ $t("car") }}</label>
          </div>
          <div class="checkbox pb-2">
            <input
              class="is-checkradio"
              type="checkbox"
              id="chk_heavy_equipment"
              name="chk_heavy_equipment"
              v-model="meta.heavy_equipment"
            />
            <label for="chk_heavy_equipment">
              {{ $t("heavy equipment") }}
            </label>
          </div>
          <div class="checkbox pb-2">
            <input
              class="is-checkradio"
              type="checkbox"
              id="chk_pickup"
              name="chk_pickup"
              v-model="meta.pickup"
            />
            <label for="chk_pickup">{{ $t("pickup") }}</label>
          </div>
          <div class="checkbox pb-2">
            <input
              class="is-checkradio"
              type="checkbox"
              id="chk_suv"
              name="chk_suv"
              v-model="meta.suv"
            />
            <label for="chk_suv">{{ $t("suv") }}</label>
          </div>
          <div class="checkbox pb-2">
            <input
              class="is-checkradio"
              type="checkbox"
              id="chk_van"
              name="chk_van"
              v-model="meta.van"
            />
            <label for="chk_van">{{ $t("van") }}</label>
          </div>
          <div class="checkbox pb-2">
            <input
              class="is-checkradio"
              type="checkbox"
              id="chk_other"
              name="chk_other"
              v-model="meta.other"
            />
            <label for="chk_other">{{ $t("other") }}</label>
          </div>
          <div class="checkbox pb-2">
            <input
              class="is-checkradio"
              type="checkbox"
              id="chk_boat"
              name="chk_boat"
              v-model="meta.boat"
            />
            <label for="chk_boat">{{ $t("boat") }}</label>
          </div>
        </div>
      </div>
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-bolt"></i>
        </span>
        <span>{{ $t("update") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "DictamenModal",
  components: { GenericModal },
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.api_token || !v.meta.items_number;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      post("/central-dispatch-tracker/service/update", v.meta)
        .then(() => {
          v.$emit("success");
          v.$refs.generic_modal.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        api_token: "",
        items_number: "100",
        offset: "0",
        order_1: "PRICE",
        order_2: "DELIVERYMETROAREA",
        car: true,
        heavy_equipment: true,
        pickup: true,
        suv: true,
        van: true,
        other: true,
        boat: true,
        settings: {},
      };
      v.error = "";
      // v.uuid = "";
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
